import React from "react";
import { connect } from "react-redux";
import { Routes, Route, Outlet, Navigate } from "react-router-dom";

/// Css
import "./index.css";


/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
import ScrollToTop from "./layouts/ScrollToTop";


/// Dashboard
import Home from "./components/Dashboard/Home";
import Rack from "./components/Rack";
import ViewRackProduct from "./components/Rack/viewProduct";
import Product from "./components/Product";
import ViewProduct from "./components/Product/viewProduct";
import StockHistory from "./components/StockHistory";
import ProductHistory from "./components/StockHistory/ProductHistory";
import BarcodeStockHistory from "./components/StockHistory/BarcodeStockHistory";
import BarcodePage from "./components/Barcode";
import EmployeePage from "./components/Employee";
import UserPage from "./components/User";
import RequisitionPage from "./components/Requisition";
import RequisitionDetails from "./components/Requisition/RequisitionDetails";
import ReservationPage from "./components/Reservation";
import ReservationDetails from "./components/Reservation/ReservationDetails";
import Settings from "./components/Settings";
import StockReport from "./components/Report";
import ForecastProducts from "./components/ForecastProduct";
import Analysis from "./components/Analysis";
import BorrowedStock from "./components/StockHistory/BorrowedStock";
import PerishableStock from "./components/Product/PerishableStock";
import ProductStocks from "./components/Product/Stocks";

/// Pages
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Login from "./pages/Login"

import logo from '../images/logo/logofullv1.png';

const allroutes = [
  // Dashboard
  { url: "dashboard", element: <Home />, permission_key: null },
  { url: "rack", element: <Rack />, permission_key: null },
  { url: "rack/:id", element: <ViewRackProduct />, permission_key: null },
  { url: "material", element: <Product />, permission_key: null },
  { url: "material/:id", element: <ViewProduct />, permission_key: null },
  { url: "stock_history", element: <StockHistory />, permission_key: null },
  { url: "stock_history/:id", element: <ProductHistory />, permission_key: null },
  { url: "barcode_stock_history/:barcode", element: <BarcodeStockHistory />, permission_key: null },
  { url: "product-stock/:id", element: <ProductStocks />, permission_key: null },
  { url: "perishable-stock", element: <PerishableStock />, permission_key: null },
  { url: "borrwed-lent-stock", element: <BorrowedStock />, permission_key: null },
  { url: "report", element: <StockReport />, permission_key: "view_report" },
  { url: "barcode", element: <BarcodePage />, permission_key: null },
  { url: "user", element: <UserPage />, permission_key: null },
  { url: "requisition", element: <RequisitionPage />, permission_key: null },
  { url: "requisition/:id", element: <RequisitionDetails />, permission_key: null },
  { url: "reservation", element: <ReservationPage />, permission_key: null },
  { url: "reservation/:id", element: <ReservationDetails />, permission_key: null },
  { url: "employee", element: <EmployeePage />, permission_key: null },
  { url: "settings", element: <Settings />, permission_key: null },
  { url: "demand-forecast", element: <ForecastProducts />, permission_key: "view_demand_forecast" },
  { url: "analysis", element: <Analysis />, permission_key: "view_analysis" }
];

const FlashScreen = () => {
  return (
    <div className="flash-screen">
      <div className="flash-body">
        <img src={logo} alt="logo" />
      </div>
    </div>
  )
}

const Markup = ({ isAuthenticated, isCheckingAuth, role, sideMenu, permission }) => {
  const NotFound = () => <Error404 />

  function MainLayout() {
    return (
      <div id="main-wrapper" className={`show ${sideMenu ? "menu-toggle" : ""}`}>
        <Nav />
        <div className="content-body" style={{ minHeight: window.screen.height - 45 }}>
          <Outlet />
        </div>
        <Footer />
      </div>
    )
  }

  const HandleUserAuthentication = ({ data, permission }) => {
    if (!isAuthenticated) {
      return <Navigate to='/' />
    } else if (role !== "Admin" && ["user", "settings"].includes(data.url)) {
      return <Error403 />;
    } else if (data.permission_key && !(permission.hasOwnProperty(data.permission_key) && !!permission[data.permission_key])) {
      return <Error403 />;
    }
    return data.element
  };

  return (isCheckingAuth ? <FlashScreen /> :
    <>
      <Routes>
        <Route path='/' exact element={isAuthenticated ? <Navigate to='/dashboard' /> : <Login />} />
        <Route element={<MainLayout />} >
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={<HandleUserAuthentication data={data} permission={permission} />}
            />
          ))}
        </Route>
        <Route path='*' element={<NotFound />} />
      </Routes>
      <ScrollToTop />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    role: state.auth.user?.role || "User",
    sideMenu: state.sideMenu,
    isAuthenticated: state.auth.user,
    isCheckingAuth: state.auth.isCheckingAuth,
    permission: state.auth.user?.user_permission || {}
  };
};

export default connect(mapStateToProps)(Markup);
